import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ab8e160a")

_pushScopeId("data-v-ab8e160a")
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-8" }
const _hoisted_4 = { class: "singlenews-title" }
const _hoisted_5 = { class: "col-4" }
const _hoisted_6 = { class: "singlenews-title" }
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-8 main-single-text" }
const _hoisted_10 = { class: "col col-sm-4" }
const _hoisted_11 = { class: "single" }
const _hoisted_12 = { class: "photosinglenews" }
const _hoisted_13 = { class: "news-date" }
const _hoisted_14 = { class: "news-cont-title1" }
const _hoisted_15 = { class: "news-cont-subtitle" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_adaptive_main_top_line = _resolveComponent("adaptive-main-top-line")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_adaptive_main_top_line),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, _toDisplayString(_ctx.article.title), 1)
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('main.otherArticles')), 1)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, [
          _createVNode("div", null, [
            _createVNode("img", {
              src: 'https://back.tourstat.kz' + _ctx.article.image
            }, null, 8, ["src"]),
            _createVNode("p", {
              innerHTML: _ctx.article.alias,
              class: "alias-text"
            }, null, 8, ["innerHTML"]),
            _createVNode("p", {
              innerHTML: _ctx.article.content,
              class: "main-text"
            }, null, 8, ["innerHTML"])
          ])
        ]),
        _createVNode("div", _hoisted_10, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.articles, (news) => {
            return (_openBlock(), _createBlock("div", {
              key: news.id,
              onClick: $event => (_ctx.reload(news.id)),
              class: "link"
            }, [
              _createVNode("div", _hoisted_11, [
                _createVNode("div", _hoisted_12, [
                  _createVNode("img", {
                    src: 'https://back.tourstat.kz' + news.image
                  }, null, 8, ["src"])
                ]),
                _createVNode("div", _hoisted_13, "от TourStat " + _toDisplayString(news.created_at), 1),
                _createVNode("div", _hoisted_14, _toDisplayString(news.title), 1),
                _createVNode("div", _hoisted_15, _toDisplayString(news.alias), 1)
              ])
            ], 8, ["onClick"]))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
})